import { React, useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import PropTypes from "prop-types";
import { StyleSheet, css } from "aphrodite";

/**
 * Checkbox
 *
 * Check box component.
 *
 * @param {*} props
 * @returns
 */
const Checkbox = (props) => {
  const {
    checked,
    className,
    helpText,
    label,
    name,
    onChange,
    required,
    value,
    onFocus,
    labelClassName,
  } = props;

  const [checkedState, setCheckedState] = useState(checked);
  const [id, setID] = useState(uuidv4());

  useEffect(() => {
    let id = uuidv4();
    setID(id);
  }, []);

  useEffect(() => {
    if (value !== undefined && value !== null && value !== "") {
      setCheckedState(value);
    }
  }, [value]);

  const handleChange = (e) => {
    const state = !checkedState;
    setCheckedState(state);
    onChange(e, state);
  };

  const handleFocus = (e) => {
    onFocus(e);
  };

  return (
    <div className={`CheckBox ${className}`}>
      <label className={labelClassName}>
        <input
          defaultChecked={checkedState}
          name={name}
          onChange={(e) => {
            handleChange(e);
          }}
          className={css(!label && styles.input)}
          required={required}
          type="checkbox"
          value={value}
          checked={checkedState}
          onFocus={handleFocus}
        />
        {label}
      </label>
      {helpText && <div className="CheckBox__help-text">{helpText}</div>}
    </div>
  );
};

const styles = StyleSheet.create({
  input: {
    marginRight: 0,
  },
});

Checkbox.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  helpText: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onFocus: PropTypes.func,
};

Checkbox.defaultProps = {
  checked: false,
  className: "",
  helpText: null,
  label: "",
  name: null,
  onChange: () => {},
  required: null,
  value: "",
  onFocus: () => {},
};

export default Checkbox;
